<template>
  <div class="workOrderProgress">
    <!-- .slice(
                    (pageConfig.pageNo - 1) * pageConfig.pageSize,
                    pageConfig.pageNo * pageConfig.pageSize
                ) -->
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%; margin-bottom: 15px"
      :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
      border
    >
      <el-table-column
        type="index"
        width="70"
        label="序号"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="orderNum"
        label="工单编号"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="customerName"
        label="老人姓名"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="ensureName"
        label="套餐类型"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="servePersonName"
        label="服务人员"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="timeStart"
        label="服务开始时间"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="timeEnd"
        label="服务结束时间"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="states"
        label="状态"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.states == 0">待派发</span>
          <span v-if="scope.row.states == 1">待处理</span>
          <span v-if="scope.row.states == 2">待回访</span>
          <span v-if="scope.row.states == 3">服务完成</span>
          <span v-if="scope.row.states == 4">待作废</span>
          <span v-if="scope.row.states == 5">已作废</span>
          <span v-if="scope.row.states == 7">异常工单</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        prop="operation"
        label="操作"
        align="center"
        width="200px"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="showLookDialog('查看', scope.row)"
            >查看</el-button
          >
          <el-button
            type="text"
            @click="promote(scope.row)"
            v-if="scope.row.timeStart == null"
            >催单</el-button
          >
          <!-- <template v-if="!onlyShowLook">
                        <el-button
                            type="text"
                            @click="showReassignmentDialog('改派', scope.row)"
                            >改派</el-button
                        >
                        <el-button
                            type="text"
                            @click="throwHandle('处理', scope.row)"
                            >处理</el-button
                        >
                        <el-button
                            type="text"
                            @click="showCancelDialog('申请作废', scope.row)"
                            >申请作废</el-button
                        >
                        <el-button
                            type="text"
                            @click="showAuditDialog('审核', scope.row)"
                            >审核</el-button
                        >
                    </template> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination_container">
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageConfig.pageSize"
        :current-page.sync="pageConfig.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageConfig.total"
        @size-change="handletableDataSize"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <!--    查看弹框-->
    <el-dialog
      :close-on-click-modal="false"
      title="查看"
      :visible.sync="lookDialogVisible"
      width="800px"
      @close="closeLookDialog"
      append-to-body
    >
      <el-form label-width="100px" :model="lookForm" ref="lookForm">
        <!-- <el-form-item label="工单编号:" prop="orderNum">
                    <el-input disabled v-model="lookForm.orderNum"></el-input>
                </el-form-item> -->
        <p class="seeTitle">客户信息</p>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户姓名：" prop="customerName">
              <el-input v-model="lookForm.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工单类型：" prop="customerType">
              <el-select
                style="width: 100%"
                v-model="lookForm.customerType"
                placeholder="请选择"
                disabled
              >
                <el-option label="商业服务工单" value="7"></el-option>
                <el-option label="残联服务工单" value="3"></el-option>
                <el-option label="老干服务工单" value="4"></el-option>
                <el-option label="民政服务工单" value="6"></el-option>
                <el-option label="文明办服务工单" value="10"></el-option>
                <el-option label="退役军人服务工单" value="14"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人：" prop="customerName">
              <el-input v-model="lookForm.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否需要其他联系方式：" prop="otherTelephone">
              <el-select
                style="width: 100%"
                v-model="lookForm.otherTelephone"
                placeholder="请选择"
                disabled
              >
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式一：" prop="customerphone">
              <el-input v-model="lookForm.customerphone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系地址：" prop="address">
              <el-input v-model="lookForm.address" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系方式二："
              prop="familyPhone"
              v-if="lookForm.otherTelephone == 1"
            >
              <el-input v-model="lookForm.familyPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系地址："
              prop="currentAddress"
              v-if="lookForm.otherTelephone == 1"
            >
              <el-input v-model="lookForm.currentAddress" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <p class="seeTitle">服务工单</p>
        <el-row>
          <el-form-item label="套餐类型:" prop="ensureName">
            <el-input disabled v-model="lookForm.ensureName"></el-input>
          </el-form-item>
          <el-col :span="12">
            <el-form-item label="服务时长：" prop="period">
              <el-input v-model="lookForm.period" disabled
                ><i slot="suffix">分钟</i></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务价格：">
              <el-input v-model="lookForm.price" disabled
                ><i slot="suffix">元</i></el-input
              >
            </el-form-item>
          </el-col>
        </el-row>
        <p class="seeTitle">服务人员</p>
        <el-row>
          <el-col :span="12">
            <el-form-item label="机构：">
              <el-input v-model="lookForm.servestationName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="站点类型：" prop="statType">
              <el-select
                style="width: 100%"
                v-model="lookForm.statType"
                placeholder="请选择"
                disabled
              >
                <el-option label="居家养老机构" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务人员：" prop="servePersonName">
              <el-input v-model="lookForm.servePersonName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式：" prop="servePersonPhone">
              <el-input v-model="lookForm.servePersonPhone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="姓名:" prop="customerName">
                    <el-input
                        disabled
                        v-model="lookForm.customerName"
                    ></el-input>
                </el-form-item>
                <el-form-item label="套餐类型:" prop="ensureName">
                    <el-input disabled v-model="lookForm.ensureName"></el-input>
                </el-form-item>
                <el-form-item label="服务人员:" prop="servePersonName">
                    <el-input
                        disabled
                        v-model="lookForm.servePersonName"
                    ></el-input>
                </el-form-item>
                <el-form-item label="开始时间:" prop="timeStart">
                    <el-input disabled v-model="lookForm.timeStart"></el-input>
                </el-form-item>
                <el-form-item label="结束时间:" prop="timeEnd">
                    <el-input disabled v-model="lookForm.timeEnd"></el-input>
                </el-form-item> -->
      </el-form>
    </el-dialog>
    <!--    改派弹框-->
    <el-dialog
      :close-on-click-modal="false"
      title="改派"
      :visible.sync="reassignmentDialogVisible"
      width="600px"
      @close="closeReassignmentDialog"
      append-to-body
    >
      <el-form
        label-width="100px"
        :model="reassignmentForm"
        ref="reassignmentForm"
      >
        <el-form-item label="选择部门:" prop="xuanzebumen">
          <el-select
            style="width: 100%"
            v-model="reassignmentForm.xuanzebumen"
            placeholder="请选择"
          >
            <el-option label="选择部门" value="选择部门"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择人员:" prop="xuanzerenyuan">
          <el-select
            style="width: 100%"
            v-model="reassignmentForm.xuanzerenyuan"
            placeholder="请选择"
          >
            <el-option label="选择人员" value="选择人员"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
        "
      >
        <el-button type="primary" @click="sendReassignment">确 定</el-button>
        <el-button @click="closeReassignmentDialog">取 消</el-button>
      </div>
    </el-dialog>
    <!--    申请作废弹框-->
    <el-dialog
      :close-on-click-modal="false"
      title="申请作废"
      :visible.sync="cancelDialogVisible"
      width="600px"
      @close="closeCancelDialog"
      append-to-body
    >
      <el-form label-width="100px" :model="cancelForm" ref="cancelForm">
        <el-form-item label="申请作废理由:" prop="shenqingzuofeiliyou">
          <el-input
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="cancelForm.shenqingzuofeiliyou"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
        "
      >
        <el-button type="primary" @click="sendCancel">确 定</el-button>
        <el-button @click="closeCancelDialog">取 消</el-button>
      </div>
    </el-dialog>
    <!--    审核弹框-->
    <el-dialog
      :close-on-click-modal="false"
      title="审核"
      :visible.sync="auditDialogVisible"
      width="600px"
      @close="closeAuditDialog"
      append-to-body
    >
      <el-form label-width="100px" :model="auditForm" ref="auditForm">
        <el-form-item label="申请作废理由:" prop="shenqingzuofeiliyou">
          <el-input
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="auditForm.shenqingzuofeiliyou"
          ></el-input>
        </el-form-item>
        <el-form-item label="提交人:" prop="tijiaoren">
          <el-input v-model="auditForm.tijiaoren"></el-input>
        </el-form-item>
        <el-form-item label="审核状态:" prop="shenhezhuangtai">
          <el-radio-group v-model="auditForm.shenhezhuangtai">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见:" prop="shenheyijian">
          <el-input
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="auditForm.shenheyijian"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
        "
      >
        <el-button type="primary" @click="sendAudit">确 定</el-button>
        <el-button @click="closeAuditDialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
  name: "workOrderProgress",
  props: {
    onlyShowLook: {
      type: Boolean,
      default: true,
    },
    openData: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 服务种类列表
      serviceTypeList: [
        { label: "家政", value: "1" },
        { label: "政府援助", value: "2" },
        { label: "维修", value: "3" },
        { label: "搬家", value: "4" },
        { label: "代购 代办", value: "5" },
        { label: "医疗", value: "6" },
      ],
      // 服务工单表格数据
      tableData: [],
      // 分页配置
      pageConfig: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      // 查看弹框
      lookDialogVisible: false,
      // 查看表单
      lookForm: {},
      // 改派弹框
      reassignmentDialogVisible: false,
      // 改派表单
      reassignmentForm: {},
      // 申请作废弹框
      cancelDialogVisible: false,
      // 申请作废表单
      cancelForm: {},
      // 审核弹框
      auditDialogVisible: false,
      // 审核表单
      auditForm: {},
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    // 催单
    promote(row) {
      // console.log(row, "催单")
      let params = {
        id: row.id,
      }
      params = Object.assign({}, params)
      this.$confirm("确认执行此操作吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/jjyl/servicePgd/plan/info/updateServicepgdReminderNum",
          method: "POST",
          data: params,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("催单成功")
            // this.showList()
          } else {
            this.$message.success("催单失败")
          }
        })
      })
    },
    // 抛出处理
    throwHandle(title, row) {
      this.$emit("handle", title, row)
    },
    // 发送审核
    async sendAudit() {},
    // 显示审核弹框
    showAuditDialog() {
      this.auditDialogVisible = true
    },
    // 关闭审核弹框
    closeAuditDialog() {
      this.auditDialogVisible = false
      this.auditForm = {}
    },
    // 发送申请作废
    async sendCancel() {},
    // 显示申请作废弹框
    showCancelDialog() {
      this.cancelDialogVisible = true
    },
    // 关闭申请作废弹框
    closeCancelDialog() {
      this.cancelDialogVisible = false
      this.cancelForm = {}
    },
    // 发送改派
    async sendReassignment() {},
    // 显示改派弹框
    showReassignmentDialog() {
      this.reassignmentDialogVisible = true
    },
    // 关闭改派弹框
    closeReassignmentDialog() {
      this.reassignmentDialogVisible = false
      this.reassignmentForm = {}
    },
    // 显示查看弹框
    showLookDialog(title, row) {
      console.log(row, "查看")
      this.lookForm = {
        orderNum: row.orderNum,
        customerName: row.customerName,
        customerType: row.customerType,
        otherTelephone: row.familyPhone == null ? "2" : "1",
        customerphone: row.customerphone,
        ensureName: row.ensureName,
        address: row.address,
        period: row.period,
        price: row.price,
        timeStart: row.timeStart,
        timeEnd: row.timeEnd,
        servePersonName: row.servePersonName,
        servestationName: row.servestationName,
        statType: "0",
        servePersonPhone: row.servePersonPhone,
        familyPhone: row.familyPhone,
        currentAddress: row.currentAddress,
      }
      this.lookDialogVisible = true
    },
    // 关闭查看弹框
    closeLookDialog() {
      this.lookDialogVisible = false
      this.lookForm = {}
    },
    // 获取表格数据
    async getTableData() {
      request({
        url: "/jjyl/servicePgd/plan/info/findPgdByBatch",
        method: "POST",
        data: {
          batch: this.openData,
          pageNo: this.pageConfig.pageNo,
          pageSize: this.pageConfig.pageSize,
        },
      }).then((res) => {
        if (res.code == 200) {
          // console.log(res.content, "详情")
          if (res.content) {
            this.tableData = res.content.list
            // this.pageConfig.pageNo = Math.ceil(
            //     res.content.length / this.pageConfig.pageSize
            // )
            this.pageConfig.total = res.content.count
          } else {
            this.tableData = []
            this.pageConfig.pageNo = 0
            this.pageConfig.total = 0
          }
        }
      })
    },
    // 每页显示条数切换
    handletableDataSize(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    // 页码切换
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
  },
}
</script>

<style scoped lang="less">
.seeTitle {
  color: rgb(22, 155, 213);
  border-bottom: 1px solid #dcdfe6;
  line-height: 40px;
  margin-bottom: 20px;
}
</style>
